import React, { useMemo } from 'react'
import { useController } from 'react-hook-form'

import { useFormContext } from './useForm'

const required = value =>
  value !== null && value !== undefined && value !== '' && value?.length !== 0

export const FormField = ({
  id,
  name,
  render,
  pattern,
  children,
  isRequired,
  valueAsDate,
  valueAsNumber,
  validate = {},
  defaultValue = null
}) => {
  const { control, isLoading } = useFormContext()

  const rules = useMemo(
    () => ({
      pattern,
      valueAsDate,
      valueAsNumber,
      validate: {
        ...(typeof validate === 'function' ? { validate } : validate),
        ...(isRequired ? { required } : {})
      }
    }),
    [pattern, valueAsDate, valueAsNumber, validate, isRequired]
  )

  const [arrayName, arrayPath] = useMemo(
    () => /^(\w(?:\w|\.)*)(?:\[\]\.?(\w(?:\w|\.)*))?$/.exec(name)?.slice(1) || [name],
    [name]
  )

  const {
    field,
    meta: { invalid: isInvalid }
  } = useController({
    name: arrayName,
    rules,
    control,
    defaultValue
  })

  const fromPath = path => elem => elem[path]
  const toPath = path => elem => ({ [path]: elem })

  const value = arrayPath ? field.value?.map(fromPath(arrayPath)) : field.value
  const onChange = arrayPath
    ? value => field.onChange(value?.map(toPath(arrayPath)))
    : field.onChange

  const otherProps =
    typeof (render || children).type == 'string'
      ? {
          required: isRequired
        }
      : {
          isLoading,
          isInvalid,
          isRequired
        }

  return React.cloneElement(render || children, { ...field, id, value, onChange, ...otherProps })
}

export default FormField
